import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, NavigationStart, RoutesRecognized, ActivatedRoute} from '@angular/router';
import { UserModel } from '../../models/user.model';
import { NotificationService } from '../../notification/swal/notification.service';
import { ImageService } from '../../services/image.service';
import { AuthService } from '../../services/auth.service';
import { ProductService } from '../../services/product.service';
import Auth from '../../helpers/auth';
import { ImageModel } from '../../models/image.model';
import Routes from '../../helpers/routes';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {

  @Input() disableClose: boolean;

  title: string;
  route: string;
  routeHome: string;
  user: UserModel;
  isCancelable: boolean;
  leftIcon: boolean;

  constructor(private router: Router, private location: Location, private activatedRoute: ActivatedRoute,
              private notificationService: NotificationService, private imageService: ImageService, authService: AuthService,
              productService: ProductService) {

    router.events.subscribe(() => {
      if (location.path() !== '') {
        this.route = location.path();
      } else {
        this.route = 'Home';
      }
    });

    authService.getAccountModel().subscribe(() => {
      this.user = Auth.getUser();
    });

    imageService.getSubject().subscribe(() => {
      this.user = Auth.getUser();
      this.findImage(this.user.foto.url);
    });

    productService.getIsCancelable().subscribe((isCancelable) => {
      this.isCancelable = isCancelable;
    });
  }

  ngOnInit() {
    this.router.events
    .filter((event) => event instanceof NavigationEnd ||  event instanceof RoutesRecognized || event instanceof NavigationStart)
    .map(() => this.activatedRoute)
    .map((route) => {
      while (route.firstChild) {
        route = route.firstChild;
      }
      return route;
    })
    .filter((route) => route.outlet === 'primary')
    .mergeMap((route) => route.data)
    .subscribe((event) => {
      this.title = Routes.getTitle(this.router.url);
    });

    this.title = Routes.getTitle(this.router.url);
    this.user = Auth.getUser();
    this.findImage(this.user.foto.url);

  }

  goTo(where: string) {
    if (where === '/login') {
      this.notificationService.showQuestionNotification('Sair do aplicativo?')
        .then(result => {
          if (result.value) {
            localStorage.clear();
            this.router.navigate([where]);
          }
        });
    } else {
      this.router.navigate([where]);
    }
  }

  goBack(): void {
    if (this.title === 'Produtos') {
      if (this.isCancelable) {
        this.location.back();
      } else {
        this.notificationService.showQuestionNotification('Deseja sair sem salvar sua alterações?')
          .then(success => {
            if (success.value) {
              this.location.back();
            }
          });
      }
    } else {
      this.location.back();
    }
  }

  changeIcon() {
    this.leftIcon = !this.leftIcon;
  }

  findImage(url) {
    this.imageService.findImage(url)
      .catch(() => {
        this.user.foto = new ImageModel();
        this.user.foto.url = '../../../assets/images/account-shadow.jpg';
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/header/header.component.ts